import { useLanguage } from "../lib/LanguageContext";

const FlagGB = () => (
  <svg viewBox="0 0 60 30" className="h-4 w-6 rounded-sm overflow-hidden">
    <clipPath id="t"><path d="M30,15h30v15zv15h-30zh-30v-15zv-15h30z"/></clipPath>
    <path d="M0,0v30h60v-30z" fill="#012169"/>
    <path d="M0,0 60,30M60,0 0,30" stroke="#fff" strokeWidth="6"/>
    <path d="M0,0 60,30M60,0 0,30" clipPath="url(#t)" stroke="#C8102E" strokeWidth="4"/>
    <path d="M30,0v30M0,15h60" stroke="#fff" strokeWidth="10"/>
    <path d="M30,0v30M0,15h60" stroke="#C8102E" strokeWidth="6"/>
  </svg>
);

const FlagGR = () => (
  <svg viewBox="0 0 27 18" className="h-4 w-6 rounded-sm overflow-hidden">
    <rect width="27" height="18" fill="#0D5EAF"/>
    <g fill="#fff">
      <rect y="2" width="27" height="2"/>
      <rect y="6" width="27" height="2"/>
      <rect y="10" width="27" height="2"/>
      <rect y="14" width="27" height="2"/>
    </g>
    <rect width="10" height="10" fill="#0D5EAF"/>
    <rect x="4" width="2" height="10" fill="#fff"/>
    <rect y="4" width="10" height="2" fill="#fff"/>
  </svg>
);

export const LanguageToggle = ({ dark = false }) => {
  const { lang, setLang } = useLanguage();
  const next = lang === "en" ? "el" : "en";
  const label = next === "el" ? "Ελληνικά" : "English";

  return (
    <button
      type="button"
      onClick={() => setLang(next)}
      data-testid="lang-toggle"
      aria-label={`Switch to ${label}`}
      title={label}
      className={`group inline-flex items-center gap-2 rounded-full border px-3 py-1.5 transition-colors ${
        dark
          ? "border-[#0a192f]/15 hover:bg-[#0a192f]/[0.04] text-[#0a192f]"
          : "border-white/30 hover:bg-white/10 text-white"
      }`}
    >
      {next === "el" ? <FlagGR /> : <FlagGB />}
      <span className="text-[10px] uppercase tracking-[0.22em] hidden sm:inline">
        {next === "el" ? "EL" : "EN"}
      </span>
    </button>
  );
};
